import { render, staticRenderFns } from "./ModalAskSchool.vue?vue&type=template&id=2222ce8d&"
import script from "./ModalAskSchool.vue?vue&type=script&lang=js&"
export * from "./ModalAskSchool.vue?vue&type=script&lang=js&"
import style0 from "./ModalAskSchool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports